var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.779785,
    width: 28,
    height: 28,
    rx: 3,
    fill: "#003149"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8654)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1622,
    height: 18.1622,
    transform: "translate(4.54102 6.07666)",
    fill: "#003149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0809 13.6467C8.24846 13.6467 7.56738 14.3278 7.56738 15.1602C7.56738 15.9927 8.24846 16.6738 9.0809 16.6738C9.91333 16.6738 10.5944 15.9927 10.5944 15.1602C10.5944 14.3278 9.91333 13.6467 9.0809 13.6467ZM18.162 13.6467C17.3295 13.6467 16.6485 14.3278 16.6485 15.1602C16.6485 15.9927 17.3295 16.6738 18.162 16.6738C18.9944 16.6738 19.6755 15.9927 19.6755 15.1602C19.6755 14.3278 18.9944 13.6467 18.162 13.6467ZM13.6214 13.6467C12.789 13.6467 12.1079 14.3278 12.1079 15.1602C12.1079 15.9927 12.789 16.6738 13.6214 16.6738C14.4539 16.6738 15.135 15.9927 15.135 15.1602C15.135 14.3278 14.4539 13.6467 13.6214 13.6467Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1622,
    height: 18.1622,
    fill: "white",
    transform: "translate(4.54102 6.07666)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable1);
export default __webpack_public_path__ + "static/media/table1.b8cfa39b698323d4707c4351f3b55780.svg";
export { ForwardRef as ReactComponent };